import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ShopModule } from '../shop.module';
import { ShopLayoutComponent } from './shop-layout.component';
import { ShopLayoutRoutingModule } from './shop-layout-routing.module';

//import { ToastrModule } from 'ngx-toastr';


@NgModule({
  declarations: [ShopLayoutComponent],
  imports: [
    CommonModule,
    RouterModule,
    ShopModule,
    ShopLayoutRoutingModule
  ],
  providers: [
    DatePipe
  ]
})
export class ShopLayoutContainerModule {
  getProductAssetsContent() {
    throw new Error('Method not implemented.');
  }
}
